import { SOCKET_EVENT } from "redux/actions/socketActions";

const initialState = { };

export const socketReducer = (state = initialState, action) => {
  switch (action.type) {
    case SOCKET_EVENT:
      return {
        ...state,
        ...action.payload
      }
    
    default:
      return state;
  }
};
